import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import getters from './getters'
import order from './modules/order'
import { getItem, setItem } from '@/utils/storage'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    reqid: getItem('REQID'),
  },
  mutations: {
    reQid(state, data) {
      state.reqid = data
      setItem('REQID', state.reqid)
    },
  },
  modules: {
    order,
    app,
    user
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js